export default class ValidateUtil {

  constructor(errors) {
    this.errors = errors;
  }

  setValidators(validators){
    this.validators = validators;
  }
  isRequiredFieldValid(fieldValue, errorKey) {
    let isValid = true;
    this.errors[errorKey] = '';

    if (!fieldValue) {
      this.errors[errorKey] = 'Field is required';
      isValid = false;
    }

    return isValid;
  }

  isStatusValid(editedIndex, params, errorKey) {
    let isValid = true;
    this.errors[errorKey] = '';

    if (params.editedIndex === -1) {
      return isValid;
    }

    if (params.newStatus === 'active' && params.oldStatus === 'canceled' && params.newStatus === params.oldStatus) {
      this.errors[errorKey] = 'You can\'t update booking with not  status canceled';
      isValid = false;
    }

    return isValid;
  }

  isChildSpaceValid(params, errorKey) {
    let isValid = true;
    this.errors[errorKey] = '';

    if (!params.selectedChildSpace && params.hasChildren) {
      this.errors[errorKey] = 'Field is required';
      isValid = false;
    }

    return isValid;
  }

  isStartTimeValid(params, errorKey) {
    let isValid = true;
    this.errors[errorKey] = '';

    if (!params.selectedStartTime) {
      this.errors[errorKey] = 'Field is required';
      isValid = false;
    }

    if (params.selectedStartTime && params.selectedEndTime && params.selectedStartTime >= params.selectedEndTime) {
      this.errors[errorKey] = 'Start time must be less then end time';
      isValid = false;
    }

    return isValid;
  }

  isEndTimeValid(params, errorKey) {
    let isValid = true;
    this.errors[errorKey] = '';

    if (!params.selectedEndTime) {
      this.errors[errorKey] = 'Field is required';
      isValid = false;
    }

    if (params.selectedStartTime && params.selectedEndTime && params.selectedStartTime >= params.selectedEndTime) {
      this.errors[errorKey] = 'End time must be more then start time';
      isValid = false;
    }

    return isValid;
  }

  areParticipantsValid(params, errorKey) {
    let isValid = true;
    this.errors[errorKey] = '';

    if (params.selectedParticipants.length  > parseInt(params.maxNumberOfParticipants)) {
      this.errors[errorKey] = `In this selected place can be ${params.maxNumberOfParticipants}-number participants`;
      isValid = false;
    }

    return isValid;
  }


  isDataValid() {
    let isValid = true;

    for (let validator of this.validators) {
      this[validator.method](validator.value, validator.errorKey);
    }

    for (let error in this.errors) {
      if (error && this.errors[error] !== '') {
        isValid = false;
      }
    }

    return isValid;
  }

}
